module.exports = __webpack_public_path__ + "static/img/Bank-e-Auctions-logo.d32fc133.png";